import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Router} from '@angular/router';
import {BoardGroupModel, BoardTableModel} from '../../../models/tasktable.model';
import {TaskServiceService} from '../../../services/task-service.service';
import { LayoutDataService } from '../../../modules/layout-global/services/lyaout-data.service';
import { MemberModel } from '../../../models/user.model';
import { MemberService } from '../../../services/member.service';
import { DialogsMTService, IconfirmDialogSettings } from '../../../services/modal/dialogs-mt.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, EMPTY, filter, Subscription, switchMap } from 'rxjs';
import { CrmService } from '../../../services/api/crm.service';
import { AlertService } from '../../../services/notify/alert.service';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';

@Component({
    selector: 'app-task-dashboards-v3',
    templateUrl: './task-dashboards-v3.component.html',
    styleUrl: './task-dashboards-v3.component.scss'
})
export class AppTaskDashboardsV3Component {
    private subs = new Subscription()
    @Input() boards: BoardTableModel[] = [];
    @Input() allGroups: BoardGroupModel[] = [];
    @Output() public emitReloading: EventEmitter<boolean> = new EventEmitter<boolean>();
    private fullAllGroups: BoardGroupModel[] = [];
    private fullBoardsList: BoardTableModel[] = [];
    public currentMember:MemberModel|undefined = undefined
    public activeGroup:number = -1
    public groupTitlesFCs:FormArray<FormControl<string|null>>|undefined = undefined
    constructor(
        private router: Router,
        private taskService: TaskServiceService,
        private layoutDataService: LayoutDataService,
        private memberService: MemberService,
        private translateService: TranslateService,
        private dialogService:DialogsMTService,
        private crmService:CrmService,
        private alertService:AlertService,
        private fb:FormBuilder,
    ) {
    }
    ngOnDestroy(): void {
        this.subs.unsubscribe()
    }
    ngOnInit(): void {
        this.memberService.getCurrentMember().then(res => this.currentMember = res);
 
        this.fullBoardsList = [...this.boards]
        this.fullAllGroups = structuredClone(this.allGroups)
        this.groupTitlesFCs = this.fb.array(this.allGroups.map(el=>el.title)) 
        this.setSubscriptions()
        if (!this.boards && !this.allGroups) {
            this.getGroupsAndBoards();
        }
    }
    setSubscriptions() {
        this.subs.add(
            this.taskService.eminOnCreateBoardGroup.asObservable().subscribe(group=>this.groupTitlesFCs?.push(new FormControl(group.title)))
        ) 
        this.subs.add(this.globalSearchSubscription())
    }
    ngOnChanges(): void {
        this.boards? this.boards.sort((a,b)=>a.alias>b.alias? 1 : -1) : null;
    }
    globalSearchSubscription () :Subscription {
        return this.layoutDataService.subGlobalSearch.asObservable().subscribe(str=>{
            this.allGroups.forEach((group,index)=>{
                group.boards = this.fullAllGroups[index].boards.filter(el=>
                el.alias.toLocaleUpperCase().includes(str.toLocaleUpperCase()) ||
                el.name.toLocaleUpperCase().includes(str.toLocaleUpperCase()))
                group.boards.length>=1? this.activeGroup = group.id : null
            })
            this.boards = this.fullBoardsList.filter(el=>
                el.alias.toLocaleUpperCase().includes(str.toLocaleUpperCase()) ||
                el.name.toLocaleUpperCase().includes(str.toLocaleUpperCase())
            )
            this.boards.length>=1? this.activeGroup = -1 : null
        })
    }
    deleteBoardGroup(id: number,title:string,event:Event): void {
        event.stopPropagation()
        let dialogSettings: IconfirmDialogSettings = {
            actionHeader: this.translateService.instant('CONFIRM.HEADERS.DELETE'),
            actionBody: this.translateService.instant('CONFIRM.TEXT.DELETE_GROUP2', {headerText: title}),
        };
        this.dialogService.confirmDialog(dialogSettings)
        .pipe (
            filter(res=>res.isConfirmed),
            switchMap(()=>this.crmService.deleteGroupById(id).pipe(
                catchError(err=>{
                    this.alertService.setAlert(err.message, 'blue')
                    return EMPTY
                })
            )),
            catchError(()=>{
                return EMPTY
            })
        )
        .subscribe(res=>{
            this.alertService.setAlert(res.message, 'nd_color');
            this.emitReloading.emit(true);

        })
    }
    changeTitle(id:number,newTitle:FormControl,event:Event) {
        event.stopPropagation()
        this.crmService.updateGroupTitle(id, newTitle.value).subscribe({
            next: () => {
                this.alertService.setAlert(this.translateService.instant('ALERTS.SUCCESS'), 'nd_color');
                let group = this.allGroups.find(el=>el.id === id)
                group? group.title = newTitle.value  : null;
                newTitle.reset(newTitle.value)
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        })
    }
    getGroupsAndBoards(): void {
        this.taskService.getAllBoards(false).then(res => {
            this.boards = res.boards.sort((a,b)=>a.alias>b.alias? 1 : -1);
            this.allGroups = res.groups;
        });
    }

    goTo(event: MouseEvent, board: BoardTableModel, road: 'settings' | 'table'): void {
        event.stopPropagation();
        if (road === 'settings') {
            void this.router.navigate(['account', 'tasks', 'options', 'statuses'], {queryParams: {alias: board.alias}});
        } else {
            this.taskService.setBoard(board.alias, true).then(() => {
                void this.router.navigate(['account', 'tasks', 'all', board.alias]);
            });
        }
    }
}
